import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-proto';
import { BatchSpanProcessor } from '@opentelemetry/sdk-trace-base';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { Resource } from '@opentelemetry/resources';
import { SEMRESATTRS_SERVICE_NAME, SEMRESATTRS_SERVICE_VERSION } from '@opentelemetry/semantic-conventions';

export function initializeTelemetry() {
  try {
    // Check if OTEL endpoint is configured
    const otlpEndpoint = process.env.VUE_APP_OTEL_ENDPOINT;
    if (!otlpEndpoint || otlpEndpoint === '') {
      return;
    }
    
    // Parse OTEL headers (format: "key1=value1,key2=value2")
    const parseDelimitedValues = (s) => {
      if (!s) return {};
      const pairs = s.split(',');
      const result = {};
      pairs.forEach(pair => {
        const [key, value] = pair.split('=');
        if (key && value) {
          result[key.trim()] = value.trim();
        }
      });
      return result;
    };
    
    const headers = parseDelimitedValues(process.env.VUE_APP_OTEL_HEADERS);
    const resourceAttrs = parseDelimitedValues(process.env.VUE_APP_OTEL_RESOURCE_ATTRIBUTES);
    
    // Create a resource with service information
    const resource = new Resource({
      [SEMRESATTRS_SERVICE_NAME]: 'taalporno-web',
      [SEMRESATTRS_SERVICE_VERSION]: '0.1.0',
      ...resourceAttrs
    });

    // Create the tracer provider
    const provider = new WebTracerProvider({
      resource: resource,
    });

    // Configure OTLP exporter
    const tracesUrl = otlpEndpoint.endsWith('/') ? `${otlpEndpoint}v1/traces` : `${otlpEndpoint}/v1/traces`;
    
    const otlpExporter = new OTLPTraceExporter({
      url: tracesUrl,
      headers: headers,
    });

    // Use batch processor for better performance
    provider.addSpanProcessor(new BatchSpanProcessor(otlpExporter));

    // Register the provider
    provider.register();

    // Register auto-instrumentations for browser
    registerInstrumentations({
      instrumentations: [
        getWebAutoInstrumentations({
          '@opentelemetry/instrumentation-fetch': {
            propagateTraceHeaderCorsUrls: /.*/,
            clearTimingResources: true,
          },
          '@opentelemetry/instrumentation-xml-http-request': {
            propagateTraceHeaderCorsUrls: /.*/,
          },
          '@opentelemetry/instrumentation-document-load': {},
          '@opentelemetry/instrumentation-user-interaction': {
            eventNames: ['click', 'submit'],
          },
        }),
      ],
    });
  } catch (error) {
    console.error('Failed to initialize OpenTelemetry:', error);
  }
}
